import { principles } from "@/mocks/voices";

export default function PrinciplesGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
      {principles.map((item) => (
        <div
          key={item.title}
          className="h-full rounded-lg bg-background-50 border border-background-200/80 p-5"
        >
          <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
            <i className={`${item.icon} text-xl`}></i>
          </span>
          <h3 className="mt-4 font-heading font-bold text-base text-foreground-900">
            {item.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  );
}